import React from 'react';

import LandingHelmet from '@rover/react-lib/src/pages/landing/components/LandingHelmet';
import { getMetaDescription } from '@rover/react-lib/src/pages/landing/SeoLocation/utils';
import type { SeoLocation } from '@rover/rsdk/src/apiClient/latest/model/seoLocation';

const SeoLocationHelmet: React.FC<{
  seoLocation: SeoLocation;
  overrideTitle?: string;
  overrideMetaDescription?: string;
  children?: React.ReactNode;
}> = ({ seoLocation, overrideTitle, overrideMetaDescription, children }) => {
  return (
    <LandingHelmet
      title={overrideTitle || seoLocation.details.seoDisplayTitle}
      metaDescription={overrideMetaDescription || getMetaDescription(seoLocation.details)}
      indexable={seoLocation.details.indexable}
    >
      <link rel="canonical" href={seoLocation.details.canonicalUrl} />
      {children}
    </LandingHelmet>
  );
};

export default SeoLocationHelmet;
